
import useCreateClass from './useCreateClass'
import useCreateShortClass from './useCreateShortClass'
import useAlert from './useAlert'
import useAlert2 from './useAlert2'
import useFormFields from './useFormFields'
import useSubmitBtns from './useSubmitBtns'
import useShortFormFields from './useShortFormFields'
import useCreateLearningGroup from './useCreateLearningGroup'
import useUpdateLearningGroup from './useUpdateLearningGroup'

export default { useCreateLearningGroup, useCreateShortClass, useUpdateLearningGroup, useAlert2, useShortFormFields, useCreateClass, useAlert, useFormFields, useSubmitBtns }